import CreateNewDefinition from "../../../../components/DataCollection/Unifier/UniqueDefinitions/CreateNewDefinition/CreateNewDefinition";

const CreateNewDefinitionScreen = () => {
  return (
    <>
      <CreateNewDefinition />
    </>
  );
};

export default CreateNewDefinitionScreen;
